import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export interface ConfirmDialogOptions {
    title: string;
    text: string;
    valid: string;
    noConfirm: boolean;
    rawText?: boolean;
    loading?: boolean;
    loadingText?: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatProgressSpinner, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class ConfirmDialogComponent {
    dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
    data = inject<ConfirmDialogOptions>(MAT_DIALOG_DATA);

    protected _defaultCtx: ConfirmDialogOptions = {
        title: '',
        text: '',
        valid: 'YES',
        noConfirm: false,
        rawText: false,
        loading: false,
        loadingText: ''
    };

    public ctx: ConfirmDialogOptions;

    constructor() {
        this.ctx = _.merge(this._defaultCtx, _.cloneDeep(this.data));
    }
    

    onNoClick(): void {
        this.dialogRef.close();
    }
}
